export const cohortBuilderSqlContentMessagesEn = {
  'projects.cohortBuilderPage.cohortBuilderSqlContent.copiedToClipboard': 'Copied SQL to clipboard',
  'projects.cohortBuilderPage.cohortBuilderSqlContent.copied': 'Copied',
  'projects.cohortBuilderPage.cohortBuilderSqlContent.copy': 'Copy SQL',
};
